// Hydration-only init
document.addEventListener('ui:hydrate', (e) => {
  const root = e.detail?.target || document
  initAll(root)
})

const locale = document.documentElement.lang || 'en-AU'
const numberFormatter = new Intl.NumberFormat(locale, {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})
const centsFormatter = new Intl.NumberFormat(locale, {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function formatMoney(amount) {
  const value = Number.isFinite(amount) ? amount : 0
  const rounded = Math.round((value + Number.EPSILON) * 100) / 100
  // Whole dollars stay short ($25); otherwise both cent digits ($7.50, not $7.5).
  return Number.isInteger(rounded)
    ? `$${numberFormatter.format(rounded)}`
    : `$${centsFormatter.format(rounded)}`
}

function initAll(scope) {
  scope.querySelectorAll('[data-qty]').forEach((wrap) => initPriceBlock(wrap))
}

function initPriceBlock(wrap) {
  const container =
    wrap.closest('form[data-product-form]') ||
    wrap.closest('[data-product]') ||
    wrap.closest('[data-cardo-cart-line]')

  const priceEl = container?.querySelector('[data-product-price]') || null
  const qtyInput =
    wrap.querySelector('input[name="quantity"]') ||
    wrap.querySelector('input[type="number"]')

  if (!priceEl || (!qtyInput && !wrap.matches('[data-qty]'))) return

  if (isNaN(parseFloat(priceEl.dataset.unitPrice))) return

  // The unit price is read each time: a deal (deal-prices.js) can change it.
  const update = (qty) => {
    const n = parseInt(qty ?? qtyInput?.value ?? 1, 10) || 1
    const { lineTotal, lineQty } = priceEl.dataset
    const exact = lineTotal && n === parseInt(lineQty, 10)
    // A tin deal's basket line can't be worked out here (the deal spreads over
    // every tin), so it dims until the basket redraws it rather than flash a
    // wrong price (Michael 2026-10-11).
    if ('dealTin' in priceEl.dataset && lineTotal) {
      container.querySelector('[data-line-price]')?.classList.toggle('opacity-50', !exact)
      if (!exact) return
    }
    priceEl.textContent = formatMoney(exact ? parseFloat(lineTotal) : parseFloat(priceEl.dataset.unitPrice) * n)
    // A deal's crossed-out normal price counts the same quantity.
    container.querySelectorAll('[data-deal-was]').forEach((s) => {
      s.textContent = formatMoney(parseFloat(s.dataset.dealWas) * n)
    })
  }
  priceEl.addEventListener('deal:price', () => update())

  // Initial draw
  update()

  // Changes from typing / +/- / programmatic
  if (qtyInput) {
    const syncFromInput = () => update(qtyInput.value)
    qtyInput.addEventListener('input', syncFromInput)
    qtyInput.addEventListener('change', syncFromInput)
  }

  wrap.addEventListener('qty:change', (e) => update(e.detail?.value))
}
